import axios from 'axios';
import { LEADS_ENDPOINT } from 'cfgCommon/endpoints'
import { TYPES } from 'src/features/leads/constants';

export async function getLeadById(leadId, updateMeliWhatsappRead = false) {
    try {
        const endpoint = new URL(`${LEADS_ENDPOINT}/${leadId}`, window.location.href)

        if (updateMeliWhatsappRead) {
            endpoint.searchParams.append('updateMeliWhatsappRead', updateMeliWhatsappRead)
        }

        const data = await axios.get(endpoint.href)
        const lead = data?.data?.data
        
        if (!lead) throw new Error('No se encontró el lead')
        const assignedUser = lead?.Opportunity_assigned_users?.filter(u => u.is_current)[0]
        return {
            id: lead?.id,
            client_name: [lead?.Client.firstname, lead?.Client.lastname].filter(Boolean).join(' '),
            client_firstname: lead?.Client.firstname,
            client_lastname: lead?.Client.lastname,
            client_id: lead?.Client.id,
            car_lot_id: lead?.car_lot_id,
            CUIT: lead?.Client.cuil_cuit,
            client_person_type: lead?.Client.client_type === TYPES.JURIDICA ? TYPES.JURIDICA : TYPES.FISICA,
            businessName: lead?.Client.business_name,
            phone: lead?.Client.phone,
            email: lead?.Client.email,
            created: lead?.createdAt,
            asignedDate: assignedUser?.createdAt,
            origin: lead?.origin,
            campaign: lead?.campaign,
            business_unit: lead?.business_unit,
            interest: lead?.interest,
            observation: lead?.observation,
            ad_id: lead?.ad_id,
            state: lead?.state,
            previous_state: lead?.previous_state,
            assignedUser: assignedUser?.assigned_user_id,
            responsibleUser: lead?.responsibleUser,
            testDrives: lead?.testDrives,
            histories: lead?.Opportunity_histories,
            leadTemperature: lead?.lead_temperature,
            assignedUserName: lead?.assignedUserName
        }
    } catch (error) {
        throw new Error(error)
    }
}
